<template>
  <vs-card>
    <section>
      <!-- <div class="header">
        <h2>Department 1</h2>
        <div>
          <vs-button type="border" @click="viewAll('department')"
            >View All</vs-button
          >
        </div>
      </div>
      <vue-horizontal-list
        :items="$store.getters['i_APC/department']"
        :options="options"
      > -->
      <!-- <template v-slot:nav-prev>
          <div>👈</div>
        </template>

        <template v-slot:nav-next>
          <div>👉</div>
        </template> -->

      <!-- <template v-slot:start>
          <div>First Item</div>
        </template>

        <template v-slot:end>
          <div>Last Item</div>
        </template> -->
      <!-- <template v-slot:default="{ item }">
          <CardEmployee :item="item" />
        </template>
      </vue-horizontal-list> -->

      <!-- <div class="header">
        <h2>Department 2</h2>
        <div>
          <vs-button  type="border" @click="viewAll('department2')">View All</vs-button>
        </div>
      </div>
      <vue-horizontal-list :items="$store.getters['i_APC/department2']" :options="options">
        <template v-slot:default="{ item }">
          <CardEmployee :item="item" />
        </template>
      </vue-horizontal-list> -->
      <div
        v-for="(item_dept, idex) in $store.getters['i_APC/department']"
        :key="idex"
      >
        <div class="header">
          <h2>
            {{
              item_dept[0].dept.charAt(0).toUpperCase() +
              item_dept[0].dept.slice(1)
            }}
            Department
          </h2>
          <div>
            <!-- <vs-button type="border" @click="viewAll(item_dept[0].dept)"
              >View All</vs-button
            > -->
          </div>
        </div>
        <vue-horizontal-list :items="item_dept" :options="options">
          <template v-slot:default="{ item }">
            <CardEmployee :item="item" />
          </template>
        </vue-horizontal-list>
      </div>
    </section>
  </vs-card>
</template>

<script>
import VueHorizontalList from "vue-horizontal-list";
import CardEmployee from "./CardEmployee.vue";

export default {
  components: {
    VueHorizontalList,
    CardEmployee,
  },
  props: {
    department: {
      type: Array,
      default: [],
    },
  },
  computed: {},
  data() {
    return {
      badge1: 1,
      options: {
        responsive: [
          { end: 576, size: 1 },
          { start: 576, end: 768, size: 2 },
          { start: 768, end: 992, size: 3 },
          { size: 6 },
        ],
        item: {
          // css class to inject into each individual item
          class: "item-horizontal-list",
          // padding between each item
          padding: 12,
        },
        list: {
          // 1200 because @media (min-width: 1200px) and therefore I want to switch to windowed mode
          windowed: 1200,

          // padding of the list, if container < windowed what is the left-right padding of the list
          // during full-screen mode the padding will added to left & right to centralise the item
          // Because: #app {padding: 80px 24px;}
          padding: 24,
        },
        position: {
          start: 0,
        },
        autoplay: { play: true, repeat: true, speed: 2500 },
      },
    };
  },
  mounted() {},
  methods: {
    viewAll(department) {
      this.$router.push({
        path: "/I-APC-RM-view-all",
        query: { department: department },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="scss" >
.item-horizontal-list {
  padding-top: 10px !important;
  padding-bottom: 15px !important;
}
</style>